class ExpandableText extends HTMLElement {
  constructor() {
    super();
    this.expanded = false;
  }

  connectedCallback() {
    // Add event listener
    const container = this.querySelector(".expandable-container");
    container.addEventListener("click", () => this.toggleExpand());
    const expenderBtn = this.querySelector(".read-more-btn");
    expenderBtn.addEventListener("click", () => this.toggleExpand());

    // Store references
    this.container = container;
  }

  toggleExpand() {
    if (!this.expanded) {
      this.container.classList.add("expanded");
      this.querySelector(".read-more-btn").style.display = "none";
      this.expanded = true;
    } else {
      this.container.classList.remove("expanded");
      setTimeout(() => {
        this.querySelector(".read-more-btn").style.display = "block";
      }, 500)
      this.expanded = false;
    }
  }
}

customElements.define("expandable-text", ExpandableText);
